/** @jsxImportSource @emotion/react */

import React from 'react';
import styled from 'styled-components';
import TextBlock from '@component/common/block/text-block';
import * as color from '@constant/color';

const Wrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 24px 16px;
  gap: 12px;
`;

// Phase 2: 회독 모드 본격 구현 시 vocabularyBookKey 받아 백엔드 단어 fetch + 객관식 4지선다 빌드 + 결과 영속화
const VocabularyBookReview: React.FC = () => {
  return (
    <Wrapper>
      <TextBlock text='회독 모드는 준비 중이에요' design={{ text: { size: 'large', color: color.BLACK_2, bold: true } }} />
      <TextBlock text='완주 후 다시 외운 단어를 점검할 수 있도록 곧 제공해 드릴게요' design={{ text: { size: 'small', color: color.GRAY_1 } }} />
    </Wrapper>
  );
};

export default VocabularyBookReview;
